module.exports = __webpack_public_path__ + "img/Aroma-Empress-pop-up.715a8c41.png";